import type { NMPLocale } from "@borealis/locale-common";
import { TextField } from "@warp-ds/react";
import React from "react";
import { useInputMaskWithLocale } from "../../hooks/useInputMask";

type RangeInputProps = {
	ariaLabel?: string;
	helpText?: string;
	invalid?: boolean;
	label?: string;
	locale: NMPLocale;
	name: string;
	onBlur?: () => void;
	onChange?: (name: string, value: string) => void;
	value?: string;
};

export function RangeInput(props: RangeInputProps) {
	const { ariaLabel, helpText, invalid = false, label, locale, name, onBlur, onChange, value = "" } = props;

	const { inputRef, maskedValue, setMaskedValue } = useInputMaskWithLocale(value, locale);

	const handleMaskedValue = React.useCallback(
		(ev: { target: EventTarget | null }) => {
			const input = ev.target as HTMLInputElement;
			if (input?.value !== undefined) {
				setMaskedValue(input.value);
				// Extract digits only and call onChange immediately
				const unmasked = input.value.replace(/[\s.,]/g, "");
				if (onChange) onChange(name, unmasked);
			}
		},
		[setMaskedValue, onChange, name],
	);

	return (
		<TextField
			aria-label={ariaLabel}
			helpText={helpText}
			inputMode="numeric"
			invalid={invalid}
			label={label}
			maxLength={11}
			name={name}
			onBlur={onBlur}
			onInput={handleMaskedValue}
			pattern="[\d\s.]+"
			ref={inputRef}
			value={maskedValue}
		/>
	);
}
